<template>
  <div class="container application" />
</template>

<script>
import config from 'config';
import { reduce, find, cloneDeep, indexOf } from 'lodash';
import HorizontalRadio from 'components/HorizontalRadio';
import HeaderUtil from 'utils/header';
import OpenAppUtil from 'utils/openApp';
import DialogUtil from 'utils/dialog';
import { isWebview } from 'utils/webview/isWebview';
import { closeWebView } from 'utils/webview/closeWebView';

export default {
  name: 'Step01',
  components: { HorizontalRadio },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    estimatePrice: {
      type: Object,
      default: () => ({}),
    },
    insurancePriceTypes: {
      type: Array,
      default: () => ([]),
    },
    repairingServices: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      planHomeUrl: config.planHome.baseURL,
      validMessage: '',
      timezone: 'Asia/Seoul',
      isErrorImg: 'false',
    };
  },
  computed: {
    valid() {
      const keyList = ['regionGroupId', 'rentRequestDate', 'rentMonths', 'carClassId', 'carTypeId', 'insurancePriceType', 'repairingService'];
      return reduce(this.data, (result, val, key) => {
        if (indexOf(keyList, key) > -1) {
          return (result && val != null && val !== '');
        } else return result && true;
      }, this.data.liValid && this.data.valid);
    },
    insurancePriceType: {
      get() {
        return this.data.insurancePriceType; // default: 50만원
      },
      set(val) {
        const data = cloneDeep(this.data);
        data.insurancePriceType = val;
        this.$emit('change', data);
      },
    },
    repairingService: {
      get() {
        return this.data.repairingService;
      },
      set(val) {
        const data = cloneDeep(this.data);
        data.repairingService = val;
        this.$emit('change', this.data);
      },
    },
    overrunDistanse() {
      return this.formatNumber(1500 * this.data.rentMonths);
    },
    // isFixedRepairingService: {
    //   get() {
    //     if (this.carType !== undefined && this.application.rentMonths !== null && this.application.rentMonths < this.carType.minRepairableMonths) {
    //       return true;
    //     } else return false;
    //   },
    // },
    // repairingServiceMessage: {
    //   get() {
    //     if (this.carType !== undefined && this.application.rentMonths !== null && this.application.rentMonths < this.carType.minRepairableMonths) {
    //       if (this.carType.minRepairableMonths > this.carType.maxRentMonths) {
    //         return '선택하신 차종은 정비 서비스 신청이 불가능합니다.';
    //       } else {
    //         return `선택하신 차종은 ${this.carType.minRepairableMonths} 개월 이상 대여 시에만 정비 서비스 신청이 가능합니다.`;
    //       }
    //     } else {
    //       return '';
    //     }
    //   },
    // },
  },
  methods: {
    openPage(url) {
      if (HeaderUtil.isAndroid()) {
        OpenAppUtil.openExternal(url);
      } else {
        window.open(url, '_blank');
      }
    },
    handleImgError(e) {
      e.target.src = '/images/car-detail-car-none.png';
    },
    next() {
      this.$emit('next', this.application);
    },
    cancel() {
      DialogUtil.confirm('취소 하시겠습니까?', () => {
        if (isWebview()) {
          closeWebView();
          return;
        }
        window.location.href = this.planHomeUrl;
      });
    },
    getInsurancePriceTypeLabel(name) {
      const selected = find(this.insurancePriceTypes, (item) => (item.name === name)) || {};
      return selected.label;
    },
  },
};
</script>

<style lang="scss" scoped>
.input-item {
  &.mt-5 {
    margin: 50px 0 0 0;
  }
  .car-count {
    margin-bottom: 10px;
  }
}

.detail {
  font-weight: normal !important;
}

.page-title-mt {
  margin-top: 5px;
}

.car-image {
  >img {
    width: 320px;
    margin-top: 16px;
  }
}
.price-details {
  padding: 5px 0 10px 0;
  &>li {
    padding: 0 0 5px 5px;
  }
}

.color-dark {
  color: black !important;
}
</style>
